import type {
  DispensaryFilterKeys,
  JaneSearchState,
  ProductFilterKeys,
} from '@jane/search/types';

import { bucketFilterKeys, rangeFilterKeys } from './constants';
import { updateSortSuffix } from './updateSortSuffix';

export const handleFilterDeselect = <T>(
  filterKey:
    ProductFilterKeys | DispensaryFilterKeys | 'all' | 'deals_and_rewards',
  searchState: JaneSearchState<T>
): JaneSearchState<T> => {
  const { bucketFilters, currentSort, filters, rangeFilters, ...restOfState } =
    searchState;

  const rootTypesFilterValues =
    (filters?.['root_types' as keyof T] as string[]) ?? [];

  let updatedFilters = filters;
  let updatedBucketFilters = bucketFilters;
  let updatedRangeFilters = rangeFilters;
  let updatedSortSuffix = currentSort?.suffix;

  if (rangeFilterKeys.includes(filterKey)) {
    updatedRangeFilters = {
      ...(rangeFilters || {}),
      [filterKey]: {},
    };
  } else if (bucketFilterKeys.includes(filterKey)) {
    updatedBucketFilters = {
      ...(bucketFilters || {}),
      [filterKey]: [],
    };
  } else if (filterKey === 'deals_and_rewards') {
    updatedFilters = {
      ...(filters || {}),
      ['has_brand_discount' as keyof T]: [],
      ['root_types' as keyof T]: rootTypesFilterValues.filter(
        (facet: string) => facet !== 'sale'
      ),
    };
  } else if (filterKey === 'root_types') {
    updatedFilters = {
      ...(filters || {}),
      ['root_types' as keyof T]: rootTypesFilterValues.filter(
        (facet: string) => facet === 'sale'
      ),
    };
  } else if (filterKey === 'applicable_special_ids') {
    updatedFilters = {
      ...(filters || {}),
      ['applicable_bulk_special_ids' as keyof T]: [],
      ['applicable_bundle_special_ids.discount' as keyof T]: [],
      ['applicable_bundle_special_ids.qualify' as keyof T]: [],
      ['applicable_cart_total_special_ids' as keyof T]: [],
      ['applicable_special_ids' as keyof T]: [],
    };
  } else {
    updatedFilters = {
      ...(filters || {}),
      [filterKey]: [],
    };

    if (updatedSortSuffix) {
      if (filterKey === 'available_weights') {
        updatedSortSuffix = updateSortSuffix(updatedSortSuffix, []);
      }
    }
  }

  if (filterKey === 'all') {
    updatedBucketFilters = undefined;
    updatedFilters = undefined;
    updatedRangeFilters = undefined;

    if (updatedSortSuffix) {
      updatedSortSuffix = updateSortSuffix(updatedSortSuffix, []);
    }
  }

  const updatedSort = currentSort;
  if (updatedSort && updatedSortSuffix) {
    updatedSort.suffix = updatedSortSuffix;
  }

  return {
    ...restOfState,
    bucketFilters: updatedBucketFilters,
    currentSort: updatedSort,
    filters: updatedFilters,
    rangeFilters: updatedRangeFilters,
  };
};
